module.exports = __webpack_public_path__ + "img/truck3.64f93e76.png";